/**
 * Wrapper class of easymarkets
 */
class EasyMarketsService {
	static isInternalRequest(){
		let result = false;
		//@todo [Dimitris] When doc.cookies migrated to ES6 change the below code to use an imported object
		if (docCookies){
			if (!docCookies.hasItem('OFFICEIP')) {
				result = docCookies.getItem('OFFICEIP') === 'true'?true:false;
			}
		}
		return result;
	}
	static getCulture(){
		return easymarkets.data.culture;
	}
	static getLanguage(){
		return easymarkets.data.language;
	}
	static isLoggedIn(){
		return easymarkets.data.logged_in;
	}
	static env(){
		return easymarkets.data.env;
	}
	static dealsizeOrigin(){
		return easymarkets.data.dealsize_origin;
	}
	static baseUrl(){
		return easymarkets.data.base_url;
	}
	static isWidgetMode() {
		return !!easymarkets.data.widget;
	}
	static getOreSessionId(){
		return easymarkets.ore.sessionId;
	}
}

export default EasyMarketsService;
